import * as jsonpointer from 'jsonpointer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getContentByRef(ref, pageModel) {
    if (!ref || !pageModel) {
        return undefined;
    }
    return jsonpointer.get(pageModel, ref);
}

export { getContentByRef };
//# sourceMappingURL=get-content-by-ref.js.map
